import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import { Avatar } from "@mui/material";
import { avatarColor, displayName, initials } from "../utils/display";

export function UserAvatar({
  username,
  email,
  authorType,
  size = 40,
}: {
  username?: string;
  email?: string;
  authorType?: "USER" | "ADMIN" | "SYSTEM";
  size?: number;
}) {
  const name = displayName(username, email, authorType === "SYSTEM" ? "SYS" : "?");
  if (authorType === "SYSTEM") {
    return (
      <Avatar sx={{ width: size, height: size, bgcolor: "#304153", fontSize: size * 0.4 }}>
        <SmartToyOutlinedIcon sx={{ fontSize: size * 0.55 }} />
      </Avatar>
    );
  }
  if (authorType === "ADMIN") {
    return (
      <Avatar sx={{ width: size, height: size, bgcolor: "#2D5F5C", fontSize: size * 0.4 }}>
        <AdminPanelSettingsOutlinedIcon sx={{ fontSize: size * 0.55 }} />
      </Avatar>
    );
  }
  return (
    <Avatar sx={{ width: size, height: size, bgcolor: avatarColor(name), fontSize: size * 0.36, fontWeight: 700 }}>
      {initials(name)}
    </Avatar>
  );
}
